import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { LIBRARY_BLOCKS_FEATURE_KEY, libraryBlocksReducer } from './library-blocks.reducer';
import { LibraryBlocksEffects } from './library-blocks.effects';
import { LibraryBlockFacade } from './library-blocks.facade';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(LIBRARY_BLOCKS_FEATURE_KEY, libraryBlocksReducer),
        EffectsModule.forFeature([LibraryBlocksEffects]),
    ],
    providers: [LibraryBlockFacade],
})
export class LibraryBlocksStoreModule {}
